var _excluded = ["color", "size"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import range from '../../util/range'; // const since these don't behave well as live props, some animation issues:

var DURATION = '1s';
var SEGMENTS = 12;

var ApmSpinner = _ref => {
  var color = _ref.color,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "-200 -200 200 200",
    version: "1.1"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M20,10 A10,10 0 1 0 20,-10 L-20,-10 A10,10 0 1 0 -20,10",
    fill: color
  })), /*#__PURE__*/React.createElement("style", null, `
      .gears-spinner {
        animation: gears-spinner-spin ${DURATION} infinite steps(${SEGMENTS});
      }
      @keyframes gears-spinner-spin {
        100% { transform: rotate(360deg); }
      }
    `), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100,-100)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "gears-spinner"
  }, range(SEGMENTS).map(i => {
    var opacity = (i / SEGMENTS).toFixed(2);
    var rotate = (i * (360 / SEGMENTS)).toFixed(2);
    return /*#__PURE__*/React.createElement("use", {
      key: i,
      xlinkHref: "#shape",
      transform: `rotate(${rotate}) translate(70, 0)`,
      opacity: opacity
    });
  }))));
};

ApmSpinner.displayName = "ApmSpinner";
ApmSpinner.defaultProps = {
  color: 'currentColor',
  size: '1em'
};
ApmSpinner.displayName = 'ApmSpinner';
export default ApmSpinner;